export const contentConstants = {
  ATTACHMENT_MAX_SIZE: 5000000, // 5MB
  IMAGE_MAX_SIZE: 5000000, // 5MB
  BUSINESS_ATTACHMENT_MAX_SIZE: 10000000, // 10MB
  BUSINESS_IMAGE_MAX_SIZE: 10000000, // 10MB
  MAX_ATTACHMENT_COUNT: 15,
  UPLOAD_LIMIT: 5
};
